import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material'
import { FilterInput } from '../../common/filterInput'
import { cellStyles, headCellStyles, rankFilteredRows } from './const'
import { useEffect, useState } from 'react'
import { getColumnDefsThree } from './DeliveryMemoTableDefs'
import React from 'react'
import { useTranslation } from '../../../i18n/I18nProvider'
import { GUJRAT_COMPANY_ID, LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL } from '../../../helper/companyIdhardcode'

const DeliveryMemoTableThree = (props) => {
  const { translations } = useTranslation()
  const dm = translations?.deliveryMemo || {}
  const columnDefsThree = getColumnDefsThree(translations)
  const { tableData, loginData, showMore } = props
  const isGujaratCompany = loginData?.intCompanyID === GUJRAT_COMPANY_ID
  const showSenderColumns = [LALA_EXPRESS, SAMAY_TRAVEL, TULSI_TRAVEL].includes(loginData?.intCompanyID)
  const visibleColumnDefsThree = columnDefsThree.filter((col) => !col.showIf || col.showIf({ isGujaratCompany, showSenderColumns }))
  const getColWidth = (col) => (isGujaratCompany && col.gtWidth ? col.gtWidth : col.width)
  const theme = useTheme()
  const { palette: cs } = theme
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  useEffect(() => {
    let newData = tableData.sort((a, b) => {
      const dateA = (new Date(a.ReceiptDateOriginal))
      const dateB = new Date(b.ReceiptDateOriginal)
      return dateB - dateA
    })
    setfilteredData(newData)
  }, [tableData])
  const handleChangeContain = (e, name) => {
    let value = e.target.value;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
    }));
  }
  useEffect(() => {
    const filteredDataTemp = tableData.filter((item) => {
      return visibleColumnDefsThree.every((column) => {
        const filterValue = filterValues[column.field] || "";
        if (!filterValue) return true
        const value = column.field === 'Sender'
          ? `${item.Sender || ''} ${item.SenderMobileNo || ''}`
          : item[column.field]
        return value && value.toString().toLowerCase().includes(filterValue.trim().toLowerCase())
      })
    })
    setfilteredData(rankFilteredRows(filteredDataTemp, filterValues, { combinedSender: true }))
  }, [filterValues])
  return (
    <>

      <TableContainer className="delivery-memo-table scroll"
        component={Paper}
        sx={{ border: '1px solid #aeaeae', borderRadius: '8px', height: showMore ? 'calc( 66vh - 160px)' : 'calc( 85vh - 150px)', overflow: 'auto', margin: '0px 0px 0px 5px' }}
      >
        <Table aria-label="a dense table" id='delivery-memo-tbl-three' sx={isGujaratCompany ? { tableLayout: 'fixed', width: '100%' } : undefined}>
          <TableHead className="table-consignment-head" style={{ position: 'sticky', top: '0', zIndex: 2 }}>
            <TableRow>
              {visibleColumnDefsThree.map((col, i) => (
                <TableCell
                  key={col.field}
                  style={{
                    ...headCellStyles,
                    width: getColWidth(col),
                    backgroundColor: '#0086ff',
                    ...(i === visibleColumnDefsThree.length - 1 ? { borderTopRightRadius: '8px' } : {})
                  }}
                >
                  {col.headerName.split('\n').map((line, j, arr) => (
                    <React.Fragment key={j}>{line}{j < arr.length - 1 && <br />}</React.Fragment>
                  ))}
                </TableCell>
              ))}
            </TableRow>
            <TableRow style={{ position: 'sticky', top: '0', zIndex: 3, background: '#fff' }}>
              {visibleColumnDefsThree.map((col) => (
                <TableCell key={col.field} style={cellStyles}>
                  <Box>
                    <FilterInput label={dm.contains || 'Contains'} marginB={true} onChange={(e) => handleChangeContain(e, col.field)} />
                  </Box>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData?.map((el, index) => (
              <DeliveryMemoRow key={'table-memo' + index} index={index} data={el} cs={cs} loginData={loginData} columnDefs={visibleColumnDefsThree} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

const DeliveryMemoRow = ({ data, loginData, columnDefs }) => {
  return (
    <TableRow>
      {columnDefs.map((col) => (
        <TableCell
          key={col.field}
          style={{
            ...cellStyles,
            border: 'none',
            borderBottom: '1px solid #ddd',
            textAlign: col.textAlign
          }}
        >
          {col.render ? (
            col.render(data, loginData)
          ) : (
            <Typography>{col.field === 'DescriptionDet' ? (data?.DescriptionDet || '') : data?.[col.field]}</Typography>
          )}
        </TableCell>
      ))}
    </TableRow>
  )
}
export default DeliveryMemoTableThree
